import { ReleaseType } from '../consts/releaseConsts'

export const releaseType = {
    [ReleaseType.CLIP]: 'Клип',
    [ReleaseType.ALBUM]: 'Альбом',
    [ReleaseType.RINGTONE]: 'Рингтон',
    [ReleaseType.SINGLE]: 'Сингл',
}
